import { render, staticRenderFns } from "./CompWrapper.vue?vue&type=template&id=2a2a33ec&lang=html&"
import script from "./CompWrapper.vue?vue&type=script&lang=js&"
export * from "./CompWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CompWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports